import { getUrls } from "../util/General";

export const routes = {
    base: getUrls().api + "/gen",
    baseVam: getUrls().api + "/vam",
    api: getUrls().api + "/gen",
    apiVam: getUrls().api + "/vam",
    root: getUrls().api,
    vam: "/vam",
    // api: api_url() + '/api',
};

export const app = {
    name: "Asistencia Médica",
    prodeseg: true,
    showPerfil: false,
    showLinkToWeb: true,
    prod: window.prod,
    linkToWeb: "https://www.google.com.ec", // todo de alguna manera saber la web a donde regresa
};
